import CheckInBaggagePostbooking from '../components/CheckInBaggagePostbooking';
import CheckInBaggagePrimaryFlow from './CheckInBaggagePrimaryFlowContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const CheckInBaggageContainer = _ref => {
  let {
    bundleData,
    form,
    includedBaggage,
    isBaggageAvailableOrIncluded,
    isPostBooking,
    order,
    orderSecondBag,
    readMore,
    productPosition,
    sellSpecification,
    secondBagProductDetails,
    shouldShowPricePerBound,
    shouldUseCarrierSpecificUnavailableLabel,
    travelerNumber
  } = _ref;
  if (isPostBooking) {
    return /*#__PURE__*/_jsx(CheckInBaggagePostbooking, {
      order: order
    });
  }
  return /*#__PURE__*/_jsx(CheckInBaggagePrimaryFlow, {
    bundleData: bundleData,
    form: form,
    includedBaggage: includedBaggage,
    isBaggageAvailableOrIncluded: isBaggageAvailableOrIncluded,
    order: order,
    orderSecondBag: orderSecondBag,
    productPosition: productPosition,
    readMore: readMore,
    secondBagProductDetails: secondBagProductDetails,
    sellSpecification: sellSpecification,
    shouldShowPricePerBound: shouldShowPricePerBound,
    shouldUseCarrierSpecificUnavailableLabel: shouldUseCarrierSpecificUnavailableLabel,
    travelerNumber: travelerNumber
  });
};
export default CheckInBaggageContainer;